import { useEffect, useRef } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Analytics() {
  const tracked = useRef(new Set());

  useEffect(() => {
    axios.post(`${API}/track/pageview`).catch(() => {});

    const sections = ["about", "programme", "programs", "location", "team", "tuition", "admissions", "forms"];
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !tracked.current.has(entry.target.id)) {
            tracked.current.add(entry.target.id);
            axios.post(`${API}/track/section/${entry.target.id}`).catch(() => {});
          }
        });
      },
      { threshold: 0.3 }
    );

    sections.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [tracked]);

  return null;
}
